import React from 'react'
import { Card, CardActionArea, CardContent, CardMedia, Typography, useTheme, CardHeader, Grid } from '@material-ui/core'
import useStyles from './styles'

const CardGames = ({ title, year, media, genre, singleplayer, multiplayer, platform, onClick }) => {
  const classes = useStyles()
  const theme = useTheme()
  const genreProps = genre.split(',')
  const newGenreProps = genreProps.length > 3 ? genreProps.slice(0, 3).join(',') + '...' : genreProps.join(',')
  const platformProps = platform.split(',')
  const newPlatformProps = platformProps.length > 3 ? '...' + platformProps.slice(0, 3).join(',') : platformProps.join(',')

  return (
    <Card className={classes.root} elevation={0}>
      <CardActionArea onClick={onClick} disableRipple>
        <CardHeader
          subheader={
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="caption">{year}</Typography>
              <Typography variant="subtitle2" style={{ fontWeight: 700 }} color="textSecondary">{newPlatformProps}</Typography>
            </Grid>
          }
        />
        <CardMedia
          component="img"
          alt={title}
          height="345"
          image={media}
        />
        <CardContent>
          <Typography gutterBottom variant="h5">
            {title?.length > 18 ? `${title.slice(0, 18)}...` : title}
          </Typography>
          <Grid container alignItems="center" className={classes.pushDown}>
            <Typography variant="subtitle2" color="textSecondary" className={classes.pushRight}>Genre:</Typography>
            <Typography variant="subtitle2" color="textPrimary">{newGenreProps}</Typography>
          </Grid>
          <Grid container alignItems="center" className={classes.pushDown}>
            <Typography variant="subtitle2" color="textSecondary" className={classes.pushRight}>Singleplayer:</Typography>
            <Typography variant="subtitle2" style={{ color: singleplayer ? theme.palette.success.main : theme.palette.error.main, fontWeight: 500 }}>{singleplayer ? 'Yes' : 'No'}</Typography>
          </Grid>
          <Grid container alignItems="center" className={classes.pushDown}>
            <Typography variant="subtitle2" color="textSecondary" className={classes.pushRight}>Multiplayer:</Typography>
            <Typography variant="subtitle2" style={{ color: multiplayer ? theme.palette.success.main : theme.palette.error.main, fontWeight: 500 }}>{multiplayer ? 'Yes' : 'No'}</Typography>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default CardGames
